import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"delete\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 .5a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5A.5.5 0 014 .5zm-4 2A.5.5 0 01.5 2h13a.5.5 0 010 1H12v9a2 2 0 01-2 2H4a2 2 0 01-2-2V3H.5a.5.5 0 01-.5-.5zM3 3v9a1 1 0 001 1h6a1 1 0 001-1V3H3zm2.5 2a.5.5 0 00-.5.5v5a.5.5 0 001 0v-5a.5.5 0 00-.5-.5zm2.5.5a.5.5 0 011 0v5a.5.5 0 01-1 0v-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id